export default function CollectionBlock() {
  return (
    <div className="nft-block –collection">
      <img src={require('../i/collection.png')} />
      <h3>Collection</h3>
      <p>UmbroID</p>
    </div>
  );
}
